// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"faf00734","539":"492626bf","787":"6f91a85e"}[chunkId] + ".chunk.js";
};